import { render, staticRenderFns } from "./KommunetorgetStartPage.vue?vue&type=template&id=1292e4e9&"
import script from "./KommunetorgetStartPage.vue?vue&type=script&lang=js&"
export * from "./KommunetorgetStartPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1292e4e9')) {
      api.createRecord('1292e4e9', component.options)
    } else {
      api.reload('1292e4e9', component.options)
    }
    module.hot.accept("./KommunetorgetStartPage.vue?vue&type=template&id=1292e4e9&", function () {
      api.rerender('1292e4e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/pages/KommunetorgetStartPage.vue"
export default component.exports